module.exports = __webpack_public_path__ + "media/images/icons/twitter_white_login-0a0a11c0be353248a4c75cb478414358.svg";